{
  "title": "Watch List",
  "header": {
    "collapse": "Collapse",
    "expand": "Expand",
    "approaching_one": "{{count}} approaching",
    "approaching_other": "{{count}} approaching",
    "thresholdSummary": "Accounts within {{percent}}% of drift threshold — monitor, no action required today"
  },
  "table": {
    "portfolio": "Portfolio",
    "accountType": "Account type",
    "reason": "Reason",
    "custodian": "Custodian",
    "value": "Value",
    "bandConsumed": "Band consumed",
    "threshold": "Threshold"
  },
  "empty": {
    "title": "No accounts approaching threshold."
  },
  "footer": {
    "configure": "Configure",
    "rowCount_one": "Showing {{count}} account",
    "rowCount_other": "Showing {{count}} accounts",
    "threshold": "Threshold: {{percent}}% band consumed"
  },
  "triggers": {
    "cashDeposit": "Cash deposit",
    "extTransfer": "Ext. transfer",
    "sectorConcentration": "Sector concentration",
    "dividendReinvestment": "Dividend reinvestment",
    "cashBand": "Cash band",
    "positionBand": "Position band"
  }
}
